import MotorTradeBuyRouteController from '@/steps/MotorTrade/MotorTradeBuyRouteController'

const MotorTrade = () => {
  return (
    <>
      <MotorTradeBuyRouteController />
    </>
  )
}

export default MotorTrade
